
<ng-template [ngIf]="fields.length">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">

    <re-captcha #captchaRef (resolved)="onRecaptchaResolved($event)" (errored)="onError($event)" errorMode="handled"
      size="invisible" siteKey="6Lf402sqAAAAAGIBPJl-Vsw54WUsJE7Uwlo3QPob" badge="bottomleft"></re-captcha>
    <input type="text" formControlName="customPotName1" style="display:none;">
    <input type="text" formControlName="customPotName2" style="display:none;">
    <input type="text" formControlName="customPotName3" style="display:none;">

    <ng-container *ngFor="let field of fields; let i = index;">
      <div class="form-group">

        <ion-label class="form-label"
          *ngIf="field.type != 'checkbox' && field.label !== 'Language Code' && field.label !== 'Type'">{{field.label}}
          <ng-template [ngIf]="field.isRequired">
            <ion-text color="danger">*</ion-text>
          </ng-template>
        </ion-label>

        <!-- TEXT -->
        <ng-template
          [ngIf]="field.type === 'text' && (!field.enum || field.enum.length === 0) && field.label !== 'Language Code' && field.label !== 'Type'">
          <ion-input [formControlName]="'field_'+i" class="form-control"
            [placeholder]="field.placeholder? field.placeholder: '' "></ion-input>
        </ng-template>


        <!-- EMAIL -->
        <ng-template [ngIf]="field.type === 'email'">
          <ion-input [formControlName]="'field_'+i" class="form-control" type="email"
            [placeholder]="field.placeholder? field.placeholder: '' "></ion-input>
        </ng-template>


        <!-- <ng-template [ngIf]="field.type === 'doc-file'">
          <input type="file" (change)="onFileChange($event, i)" class="form-control" id="fileInput_{{i}}" style="display: none;"
            accept=".pdf,.doc,.docx">
          <button type="button" class="btn btn-icon" (click)="uploadFile(i)" title="Upload file">
            <img src="./assets/img/332-01-512.webp" alt="Upload Icon" style="width: 24px; height: 24px;">
          </button>
          <span *ngIf="fileNames[i]">{{ fileNames[i] }}</span>
        </ng-template>
        
        
        <ng-template [ngIf]="field.type === 'image-file'">
          <input type="file" (change)="onFileChange($event, i)" class="form-control" id="fileInput_{{i}}" style="display: none;"
            accept=".jpg,.jpeg,.png,.gif">
          <button type="button" class="btn btn-icon" (click)="uploadFile(i)" title="Upload file">
            <img src="./assets/img/332-01-512.webp" alt="Upload Icon" style="width: 24px; height: 24px;">
          </button>
          <span *ngIf="fileNames[i]">{{ fileNames[i] }}</span>
        </ng-template> -->

        <ng-container *ngIf="field.type === 'doc-file' || field.type === 'image-file'">
          <div class="upload-container">
            <input type="file" id="fileInput_{{i}}" (change)="onFileChange($event, i)" #fileInput hidden
              [accept]="field.type === 'doc-file' ? '.pdf,.doc,.docx' : '.jpg,.jpeg,.png,.gif'" />
            <label for="fileInput_{{i}}" class="upload-box">
              <div *ngIf="!fileNames[i] || !uploadSuccess[i]">
                <img src="./assets/img/332-01-512.webp" alt="Upload Icon" class="upload-icon" />
                <p>Select a file to upload</p>
                <button type="button" class="browse-btn" (click)="uploadFile(i)">Browse</button>
              </div>
              <div *ngIf="fileNames[i] && uploadSuccess[i]">
                <p class="file-preview">{{ fileNames[i] }}</p>
                <button type="button" class="browse-btn" (click)="uploadFile(i)">Change File</button>
              </div>
            </label>
          </div>
        </ng-container>




        <!-- NUMBER -->
        <ng-template [ngIf]="field.type === 'number'">
          <ion-input [formControlName]="'field_'+i" class="form-control" type="number"
            [placeholder]="field.placeholder? field.placeholder: '' "></ion-input>
        </ng-template>

        <!-- TEXTAREA -->
        <ng-template [ngIf]="field.type === 'textarea'">
          <ion-textarea [formControlName]="'field_'+i" class="form-control" autoGrow="true"
            [placeholder]="field.placeholder? field.placeholder: '' "></ion-textarea>
        </ng-template>

        <!-- DATE -->
        <ng-template [ngIf]="field.type === 'date'">
          <ion-datetime [formControlName]="'field_'+i" [name]="config.name" [id]="config.name"
            [displayFormat]="'DD/MM/YYYY'" [required]="field.isRequired ? true : false"
            [placeholder]="field.placeholder? field.placeholder: '' "></ion-datetime>
        </ng-template>

        <!-- CHECKBOX -->
        <ng-template [ngIf]="field.type === 'checkbox'">
          <ion-list>
            <ion-item lines="inset">

              <ion-label class="form-label" slot="">{{field.label}}
                <ng-template [ngIf]="field.isRequired">
                  <ion-text color="danger">*</ion-text>
                </ng-template>

              </ion-label>
              <ion-checkbox [formControlName]="'field_'+i" mode="ios" slot="start"
                (ionChange)="updateCheckbox($event, i)"></ion-checkbox>
            </ion-item>
          </ion-list>



        </ng-template>

        <!-- DROPDOWN -->
        <ng-template [ngIf]="field.type === 'dropdown' && field.enum && field.enum.length > 0">
          <ion-list>
            <ion-select [formControlName]="'field_'+i" interface="action-sheet">
              <ion-select-option *ngFor="let option of field.enum" [value]="option">{{option}}</ion-select-option>
            </ion-select>
          </ion-list>
        </ng-template>


        <!-- LIST AUTOCOMPLETE -->
        <ng-template [ngIf]="field.type === 'list-autocomplete'">
          <div class="m-t-5">
            <app-list-autocomplete [$list]="field.$listCode" [model]="form.get('field_'+i).value"
              [config]="{ placeholder:field.placeholder?  field.placeholder : ''  }"
              (onSelectedEvent)="onListItemSelect($event, 'field_'+i)"></app-list-autocomplete>
          </div>
        </ng-template>

        <ng-template
          [ngIf]="form.get('field_'+i).invalid && (form.get('field_'+i).dirty || form.get('field_'+i).touched)">
          <ng-template [ngIf]="form.get('field_'+i).hasError('required')">
            <ion-text color="danger" class="m-b-5 m-t-5">
              <span class="f-14">{{field.label}} is required</span>
            </ion-text>
          </ng-template>
        </ng-template>





      </div>
    </ng-container>

    <div class="form-group">
      <div [ngStyle]="wrapperStyle">
        <ion-button type="submit" mode="ios" fill="outline" #submitButtonRef
          [attr.disabled]="(form.invalid || inProgress)" [size]="submitButton.size">

          <ng-template [ngIf]="inProgress">
            <ion-spinner color="primary"></ion-spinner>
          </ng-template>
          <ng-template [ngIf]="!inProgress">{{submitButton.text}}</ng-template>
        </ion-button>
      </div>

    </div>

  </form>
</ng-template>

